import React from "react";
import { pageTitle } from "../../helpers/PageTitle";

export default function TermsPage() {
  pageTitle("Terms of Use");
  return (
    <main className="mx-auto max-w-4xl px-6 pb-20 pt-40 text-slate-700">
      <h1 className="mb-6 text-4xl font-bold text-slate-900">Terms of Use</h1>
      <div className="space-y-6 leading-8">
        <p>The content on this website is provided for general information about Algostine’s services and does not constitute a binding proposal or technical guarantee.</p>
        <p>Project scope, deliverables, timelines, service levels, confidentiality, and fees are governed by the written agreement signed for the relevant engagement.</p>
        <p>You may not misuse this website, attempt unauthorized access, or reproduce its content without permission.</p>
      </div>
    </main>
  );
}
